import React from 'react';

// Components
import TargetList from './components/TargetList';

// Types
import Locale from '@/types/locale';
import { RiskProfileConfigRequirements } from '@/types/risk-profiles/risk-profiles';

// Utils
import { transformRequirementsToTargets } from './utils/target-transformers';

interface TargetsFromRequirementsProps {
  requirements?: RiskProfileConfigRequirements[];
  locale: Locale;
}

const TargetsFromRequirements: React.FC<TargetsFromRequirementsProps> = ({ requirements, locale }) => {
  if (!requirements?.length) {
    return null;
  }

  const targets = transformRequirementsToTargets(requirements, locale);

  return <TargetList targets={targets} />;
};

export default TargetsFromRequirements;
